module.exports = __webpack_public_path__ + "static/img/0019.3c89ac4f.png";